//@flow
import React, { useContext, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../locales/components/namespaces";
import { TitleContext } from "../../../pages/main/content";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ExhibitionStatus from "../exhibitionStatus/exhibitionStatus";
import { Chip } from "@mui/material";
import { formatDate } from "../../../helpers/date";
import { useMultilingualText } from "../../../hooks/useMultilingualText";
import { normalizeGreek } from "../../../helpers/normalizeGreek";
import useUserData from "../../../hooks/user/useUserData";
import { showOption } from "../../../helpers/helpers";

export const PageTitleContent = ({ exhibition, customTypographyStyles = {} }) => {
	const { dateFrom, dateTo, coorganizationDescription, isMain } = exhibition
	const {t} = useTranslation(EXHIBITION)
	const title = useMultilingualText(exhibition.title)
	const { language } = useUserData()
	const coorgDescr = normalizeGreek(showOption(language)(coorganizationDescription).toUpperCase())
	return (
		<Typography variant="h5" color={'text.main'} component="div" sx={{...customTypographyStyles}}>
			<Box>
				{normalizeGreek(title?.toUpperCase())}
			</Box>
			<Box sx={{ fontSize: '12px'}}>
				{Boolean(coorgDescr) && (`${t('Member of Coorganization')}:`)} {coorgDescr}
			</Box>
			<Box sx={{
				'& .MuiChip-root': {
					height: 20,
					borderRadius: "8px",
					p: '4px 16px'
				}
			}}>
				<ExhibitionStatus
					sx={{ mr: 1 }}
					dateTo={dateTo}
					dateFrom={dateFrom}
				/>
				<Chip
					sx={{ mr: 1, color: '#31373A'}} size={"small"}
					label={formatDate(dateFrom.locale(language), formatDate.formatTypes.FULL_DESCRIPTION)}
				/>
				<Chip
					size={"small"}
					sx={{ color: '#31373A'}}
					label={formatDate(dateTo.locale(language), formatDate.formatTypes.FULL_DESCRIPTION)}
				/>
				{isMain && (
					<Chip
						variant="contained"
						color={'success'}
						size={"small"}
						sx={{padding: '2px', margin: '0 2px'}}
						label={t("Main Coorganization Exhibition")}
					/>
				)}
			</Box>
		</Typography>
	)
}
const ExhibitionPageTitle = ({ exhibition }) => {
	const { setTitle } = useContext(TitleContext)
	const { language } = useUserData()
	useEffect(() => {
		setTitle(
			<PageTitleContent
				exhibition={exhibition}
				language={language}
			/>
		)
		return () => {
			setTitle(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [language])
	return null
}

export default ExhibitionPageTitle;